/**
 * Lightbox Gallery Functionality. 
 * Still need a way to distinguish between multiple galleries.
 *
 * @package   seedyjoints
 * @since     JointsWP
 * @author    <john@chatmandesign.com>
 * @link      http://chatmandesign.com
 */
(function($) {
    const arriveOptions   = {
        onceOnly: true, // ensure that registered callbacks fire only once
        existing: true, // ensure that the registered callback is fired for the elements that already exist in the DOM and match the selector
    };

    const slideSelector         = '.slide div[data-slide-id]';
    const openModal             = '.gallery-modal.open';
    let $lightboxGallery        = $('.wp-block-cd-lightbox-gallery');
    let $galleryModal           = $('.gallery-modal');
    let $modalSlider            = $('.gallery-modal .slides');
    let $closeButton            = $('.gallery-modal .options .close');
    let $navArrows              = $('.gallery-modal .options .slick-arrow');

    let lightboxActiveTab = false;

    function scaleImages() {
        $lightboxGallery.each(function() {
            $(this).find('.thumb').each(function() {
                let $image = $(this).find('img');
                scaleImageContainer($(this), $image);
            });
        });
    }

    function scaleSlider() {
        $('.gallery-modal .content').each(function(index) {
            let $slideImage = $(this).find('img');
            scaleImageContainer($(window), $slideImage, true);
        });

    }

    function initGalleryModal() {
        $lightboxGallery.each(function() {
            $(this).find($galleryModal).each(function() {
                let slides = $(this).find(slideSelector);
                $(slides[0]).addClass('active');
                $(this).appendTo('body');
            });
        });
    }

    function focusLightboxClose(event) {
        if( !lightboxActiveTab ) {
            event.preventDefault;
            $navArrows.focus(); // first menu item focused
            lightboxActiveTab = true;
        }
    }

    function advanceSlider(forward) {
        let banners             = $modalSlider.find(slideSelector);
        let numBanners          = banners.length;
        let firstBanner         = banners[0]; 
        let lastBanner          = banners[numBanners - 1];
        let currentBannerIndex  = 0;
        for(let i = 0; i < numBanners; i++) {
            let $currBanner = $(banners[i]);
            if( $currBanner.hasClass('active') ) {
                currentBannerIndex = i;
                break;
            }
        }
        let $currentBanner  = $(banners[currentBannerIndex]);
        let $nextBanner     = '';
        let isRepeat        = true;

        if( forward ) {
            isRepeat = currentBannerIndex === numBanners - 1;

            if( isRepeat ) {
                $currentBanner = $(lastBanner);
                $nextBanner = $(banners[0]);
            } else {
                $nextBanner = $(banners[currentBannerIndex + 1]);
            }
        } else {
            isRepeat = $(firstBanner).hasClass('active');

            if( isRepeat ) {
                $currentBanner = $(firstBanner);
                $nextBanner = $(banners[numBanners - 1]);
            } else {
                $nextBanner = $(banners[currentBannerIndex - 1]);
            } 
        }

        $nextBanner.addClass('active');
        $currentBanner.removeClass('active');
    }

    function openSlider(id, galleryName) {
        let gallery = '.gallery-modal';
        if( galleryName ) gallery += `[data-gallery-name="${galleryName}"]`;

        let currentSlider = $modalSlider.find('div.active');
        if( currentSlider.attr('data-slide-id') != id ){
            currentSlider.removeClass('active');
            let activeSlide = $galleryModal.find(`[data-slide-id="${id}"]`);
            $(activeSlide).addClass('active');
        }
        $(gallery).css('visibility', 'visible');
        setTimeout(function() {
            $(gallery).addClass('open');
        }, 10); 
    }

    function closeSlider(galleryName) {
        lightboxActiveTab = false;
        let gallery = '.gallery-modal';
        if( galleryName ) gallery += `[data-gallery-name="${galleryName}"]`;

        $(gallery).removeClass('open');
        setTimeout(function() {
            $(gallery).css('visibility', 'hidden'); 
        }, 550); // extra 50ms for full fade out
    }

    $(document).arrive('.wp-block-cd-lightbox-gallery', arriveOptions, scaleImages);
    $(document).arrive('.gallery-modal', arriveOptions, initGalleryModal);

    $(window).on('load resize', function() {
        scaleImages();
        scaleSlider();
    });

    $(window).on('load', function () {
        // Make sure banners are still scaled if data isn't available on arrive
        initGalleryModal();

        $lightboxGallery.find('.thumb').each(function() {
            $(this).on('keydown', function(event) {
                if( $(this).is(':focus') && event.keyCode == 13 ) {
                    let slideId = $(this).attr('data-slide-id');
                    let parent = $(this).closest('.thumbs');
                    let galleryName = $(parent).attr('data-gallery-name');
                    openSlider(slideId, galleryName);
                }
            });

            $(this).on('click', function () {
                let slideId = $(this).attr('data-slide-id');
                let parent = $(this).closest('.thumbs');
                let galleryName = $(parent).attr('data-gallery-name');
                openSlider(slideId, galleryName);
            });
        });

        $closeButton.on('click', function() {
            let parent = $(this).closest('.gallery-modal');
            let galleryName = $(parent).attr('data-gallery-name');
            closeSlider(galleryName);
        });

        $navArrows.each(function() {
            $(this).on('click', function() {
                if($(this).hasClass('slick-prev')) {
                    advanceSlider(false);
                } else if($(this).hasClass('slick-next')) {
                    advanceSlider(true);
                }
            });
        });

        $(this).on('keydown', function(event) {
            let $openModal = $(openModal);
            if( $openModal.length ) {
                let galleryName = $openModal.attr('data-gallery-name');
                switch(event.keyCode) {
                    case 27:
                        closeSlider(galleryName);
                        break;
                    case 37:
                        advanceSlider(false);
                        break;
                    case 39:
                        advanceSlider(true);
                        break;
                    case 9:
                        focusLightboxClose(event);
                        break;
                }
            }

        });

    });

    window.addEventListener("orientationchange", function() {
        scaleSlider();
    }, false);

    let isDragging = false;
    let xDrag = null;
    let yDrag = null;

    $galleryModal.on('mousedown', function(event) {
        event.preventDefault();
        isDragging = false;                             
        xDrag = event.pageX;                                      
        yDrag = event.pageY;
        $(this).addClass('is-grabbing');                                      
    })
    .on('mousemove', function(event) {
        isDragging = true;
    })
    .on('mouseup', function(event) {
        if ( ! xDrag || ! yDrag ) {
            return;
        }
        let wasDragging = isDragging;

        if(wasDragging) {
            let xUp = event.clientX;                                    
            let yUp = event.clientY;
        
            let xDiff = xDrag - xUp;

            let isThresholdMet = Math.abs( xDiff ) > 100;
            if( isThresholdMet ) {
                if ( xDiff > 0 ) {
                    // left swipe
                    advanceSlider(false);
                } else {
                    // right swipe
                    advanceSlider(true);
                }
            }

        }

        // reset values
        xDrag = null;
        yDrag = null;   
        isDragging = false;
        $(this).removeClass('is-grabbing');
    });


})(jQuery);